import { withCompInfo } from '@wix/editor-elements-integrations'
import { colorApi } from '@wix/thunderbolt-becky-root'
import { ContainerCss, ContainerDefinition } from './Container'

export const css = withCompInfo<ContainerCss, ContainerDefinition>()(
	['styleProperties', 'siteColors'],
	({ styleProperties, siteColors }) => {
		const brightnessParams = colorApi.getBrightnessCSSVars({
			siteColors,
			styleProperties,
		})

		return brightnessParams
	}
)
